import { useState, useEffect } from 'react'
import { getEducationTypeAPI } from '../services/education'

function UseEducationTypes() {
  const [data, setData] = useState([])
  useEffect(() => {
    const getData = async () => {
      const result = await getEducationTypeAPI()
      if (!result) return
      if (result.status) {
        const newData = result.result.map((d, i) => {
          return { value: d.id, label: d.education }
        })

        setData(newData)
      }
    }
    getData()
  }, [])

  return data
}

export default UseEducationTypes
